export default "__VITE_ASSET__Ck6qdy_M__";